import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: '해양산업 컨퍼런스',
    description: '해양 기술과 글로벌 연결, 혁신과 협력의 미래를 함께 그리는 해양산업 컨퍼런스입니다.',
    url: getOrigin()
}
